import { render, staticRenderFns } from "./status-request-icon.vue?vue&type=template&id=bc2f5900"
import script from "./status-request-icon.vue?vue&type=script&lang=js"
export * from "./status-request-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports